import React, {useCallback, useState} from 'react';
import {Col, Container, Row, Button} from 'reactstrap';
import classNames from 'classnames';
import SectionCL from 'components/ComponentLibrary/SectionCL';
import FacebookCommentFeed from 'components/Social/FacebookCommentFeed';
import './CommentSection.scss';

export default function CommentSection({id, className = undefined, ...props}) {
  const [commentsKey, setCommentsKey] = useState(0);
  const refreshComments = useCallback(() => setCommentsKey((commentsKey) => commentsKey + 1), []);

  return (
    <SectionCL id={id} color="white" className={classNames(`section-comments`, className)} angle="none" order="last">
      <Container>
        <Row>
          <Col>
            <div className="comment-box">
              <Row className="text-center mb-4 mb-lg-5">
                <Col xs="12">
                  <h3 className="section-heading mb-4">Share Your Comments, Highlights, & Celebrations</h3>
                  <Button className="btn btn-lg btn-refresh text-uppercase" onClick={refreshComments}>
                    Get The Latest Comments
                  </Button>
                </Col>
              </Row>
              <Row id="comment">
                <Col xs="12">
                  <FacebookCommentFeed key={commentsKey} {...props} />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </SectionCL>
  );
}

export function CommentSectionInline({...props}) {
  const [commentsKey, setCommentsKey] = useState(0);
  const refreshComments = useCallback(() => setCommentsKey((commentsKey) => commentsKey + 1), []);

  return (
    <div className={classNames(`comment-box-inline`)}>
      <div className="comment-box-inline-tools text-center mb-3">
        <p className="text-small text-800">Share Your Comments, Highlights, & Celebrations</p>
        <Button className="btn btn-refresh text-uppercase" onClick={refreshComments}>
          Get The Latest Comments
        </Button>
      </div>
      <FacebookCommentFeed containerClass="p-0" {...props} key={commentsKey} />
    </div>
  );
}
